module.exports = __webpack_public_path__ + "img/logo.0080b059.png";